<template>
  <div style="padding:20px;" class="bloc has-text-centered">
    <!-- text thanks -->
    <h2>{{ sondage_presentation }}</h2>
    <div class="mt-2">
      <button style="width:auto" class="button-client" @click="showQuestions">
        {{ " " }}{{ $t("question.suivant") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Thanks',
  props: {
    sondage_presentation: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      timer: 0,
      increment: 5,
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(['steps', 'type_formulaire', 'showResultsClient'])
  },
  created () {},
  methods: {
    showQuestions () {
      this.$store.commit('UPDATE_SHOW_SONDAGE_PRESENTATION', false)
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/Presentation.vue